import { Features } from './features';

export const featureFlagsSelector = (state: any): Features => state.features.features;
